export enum HtmlDocType {
  PRIVACY,
  AGB,
  IMPRESSUM
}